import Constants from "~/helpers/enums/Constants";

const initialState = {
    sessionsPackagesAvailable: [],
    sessionsAccepted: []
}

const checkUserPackageSessionsReducer = (state = initialState, action = null) => {
    switch (action.type) {
        case Constants.SET_SESSIONS_PACKAGES_AVAILABLE:
            return {
                ...state,
                sessionsPackagesAvailable: action.payload.sessionsPackagesAvailable,
            }
            case Constants.SET_SESSIONS_ACCEPTED: {
                const incomingArray = action.payload.data || []; 
                const keyOf = (s) => s.bookingId; 
              
                const byId = new Map(state.sessionsAccepted.map((s) => [keyOf(s), s]));
                for (const item of incomingArray) {
                  byId.set(keyOf(item), item); 
                }
                const sessionsAccepted = Array.from(byId.values());
                return { ...state, sessionsAccepted };
            }
            case Constants.CLEAR_SESSIONS_ACCEPTED:
                return {
                    ...state,
                    sessionsAccepted: []
                }
        default: 
            return state;
    }
};

export default checkUserPackageSessionsReducer;